(function () {
  'use strict';

  var addInFlight = false;
  var DEBUG_KEY = 'revival_cart_debug';

  function debugEnabled() {
    try {
      return window.sessionStorage && window.sessionStorage.getItem(DEBUG_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function log() {
    if (!debugEnabled()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[RevivalCart]');
    console.log.apply(console, args);
  }

  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[RevivalCart]');
    console.warn.apply(console, args);
  }

  function errorLog(details) {
    try {
      console.error('[RevivalCart][ATC failure]', details);

      try {
        var stored = JSON.parse(window.sessionStorage.getItem('revival_cart_failures') || '[]');
        stored.push(Object.assign({ timestamp: new Date().toISOString() }, details));
        window.sessionStorage.setItem('revival_cart_failures', JSON.stringify(stored.slice(-20)));
      } catch (e) {}

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'revival_cart_error',
          revival_cart_stage: details.stage || 'unknown',
          revival_cart_status: details.status || 0,
          revival_cart_message: details.message || ''
        });
      } catch (e) {}

      try {
        if (typeof window.clarity === 'function') {
          window.clarity('event', 'revival_cart_error');
          window.clarity('set', 'revival_cart_error_stage', String(details.stage || 'unknown'));
        }
      } catch (e) {}

      window.dispatchEvent(new CustomEvent('revival:cart:error', { detail: details }));
    } catch (e) {
      console.error('[RevivalCart][ATC failure]', details);
    }
  }

  function getRebuy() {
    return window.Rebuy && window.Rebuy.SmartCart ? window.Rebuy : null;
  }

  function setSkipOpen(value) {
    var rebuy = getRebuy();
    if (rebuy && rebuy.SmartCart) {
      rebuy.SmartCart.skip_open = !!value;
    }
  }

  document.addEventListener('rebuy:cart.ready', function () {
    if (addInFlight) setSkipOpen(true);
  });

  function clearError(button) {
    var scope = button && button.closest ? (button.closest('form') || button.parentElement) : document;
    var old = scope && scope.querySelector ? scope.querySelector('.revival-cart-error') : null;
    if (old) old.remove();
  }

  function showError(message, button) {
    var text = message || 'We could not add this item to your cart. Please try again.';
    console.error('[RevivalCart]', text);

    if (!button || !button.parentNode) return;
    clearError(button);

    var el = document.createElement('div');
    el.className = 'revival-cart-error';
    el.setAttribute('role', 'alert');
    el.style.cssText = 'margin-top:10px;color:#b42318;font-size:14px;line-height:1.35;';
    el.textContent = text;
    button.parentNode.insertBefore(el, button.nextSibling);
  }

  function parseError(payload, response) {
    if (payload) {
      if (typeof payload === 'string') return payload;
      if (payload.description) return payload.description;
      if (payload.message) return payload.message;
      if (payload.errors) {
        if (typeof payload.errors === 'string') return payload.errors;
        try { return JSON.stringify(payload.errors); } catch (e) {}
      }
    }
    return 'Unable to add this item to cart' + (response ? ' (' + response.status + ')' : '') + '.';
  }

  async function getShopifyCart() {
    var response = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Could not refresh Shopify cart (' + response.status + ').');
    return response.json();
  }

  function expectedVariantIds(formData) {
    if (!formData || !Array.isArray(formData.items)) return [];
    return formData.items
      .map(function (item) { return Number(item && item.id); })
      .filter(function (id) { return Number.isFinite(id) && id > 0; });
  }

  function cartHasExpectedItems(cart, ids) {
    if (!ids.length) return !!(cart && cart.item_count > 0);
    var present = new Set((cart.items || []).map(function (item) { return Number(item.variant_id || item.id); }));
    return ids.every(function (id) { return present.has(id); });
  }

  function waitForRebuy(timeoutMs) {
    timeoutMs = timeoutMs || 1800;
    return new Promise(function (resolve) {
      var started = Date.now();
      (function check() {
        var rebuy = getRebuy();
        if (rebuy) return resolve(rebuy);
        if (Date.now() - started >= timeoutMs) return resolve(null);
        setTimeout(check, 50);
      })();
    });
  }

  async function syncRebuy(cart, showCart) {
    var rebuy = await waitForRebuy(1800);
    if (!rebuy) {
      if (showCart !== false) window.location.href = '/cart';
      return;
    }

    try {
      if (typeof rebuy.SmartCart.setCart === 'function') {
        rebuy.SmartCart.setCart(cart);
      }
      if (rebuy.Cart && typeof rebuy.Cart.fetchShopifyCart === 'function') {
        await new Promise(function (resolve) {
          var done = false;
          function finish() { if (!done) { done = true; resolve(); } }
          try {
            rebuy.Cart.fetchShopifyCart(function () { finish(); });
            setTimeout(finish, 700);
          } catch (e) {
            finish();
          }
        });
      }
    } catch (e) {
      warn('Rebuy sync warning:', e);
    }

    if (typeof rebuy.SmartCart.setCart === 'function') {
      rebuy.SmartCart.setCart(cart);
    }

    rebuy.SmartCart.skip_open = false;
    if (showCart !== false) rebuy.SmartCart.show();
  }

  async function settleGiftAndCart(cart) {
    if (window.RevivalGift && typeof window.RevivalGift.syncAfterCartChange === 'function') {
      try {
        var giftCart = await window.RevivalGift.syncAfterCartChange(cart);
        if (giftCart && Array.isArray(giftCart.items)) return giftCart;
      } catch (e) {
        warn('Gift sync warning:', e);
      }
    }
    return getShopifyCart();
  }

  async function add(formData, options) {
    options = options || {};
    var button = options.button || null;
    var showCart = options.showCart !== false;
    clearError(button);

    if (!formData || !Array.isArray(formData.items) || formData.items.length === 0) {
      var emptyError = new Error('Please select a product option before adding to cart.');
      showError(emptyError.message, button);
      throw emptyError;
    }

    if (addInFlight) {
      var busyError = new Error('Your previous cart update is still processing. Please wait a moment.');
      showError(busyError.message, button);
      throw busyError;
    }

    addInFlight = true;
    setSkipOpen(true);
    if (button) button.disabled = true;

    var startedAt = Date.now();

    try {
      log('Adding items', formData.items);
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      var payload = null;
      try { payload = await response.json(); } catch (e) {}

      if (!response.ok) {
        var reason = parseError(payload, response);
        errorLog({
          stage: 'cart_add',
          status: response.status,
          statusText: response.statusText,
          message: reason,
          items: formData.items,
          url: window.location.href,
          durationMs: Date.now() - startedAt,
          payload: payload
        });
        throw new Error(reason);
      }

      var ids = expectedVariantIds(formData);
      var cart = null;
      for (var attempt = 0; attempt < 4; attempt++) {
        if (attempt) await new Promise(function (r) { setTimeout(r, 100 * attempt); });
        cart = await getShopifyCart();
        if (cartHasExpectedItems(cart, ids)) break;
      }

      if (!cart || !cartHasExpectedItems(cart, ids)) {
        errorLog({
          stage: 'cart_confirmation',
          message: 'Added variants were not found in /cart.js',
          expectedVariantIds: ids,
          cart: cart,
          url: window.location.href,
          durationMs: Date.now() - startedAt
        });
        throw new Error('The item was not confirmed in your cart. Please try again.');
      }

      window.dispatchEvent(new CustomEvent('revival:cart:confirmed', {
        detail: { cart: cart, source: 'revival-cart', items: formData.items }
      }));

      // Free gift is now a post-confirmation operation, not a global fetch/XHR interceptor.
      cart = await settleGiftAndCart(cart);
      await syncRebuy(cart, showCart);

      log('Cart confirmed', cart);
      return { result: payload, cart: cart, response: response };
    } catch (error) {
      showError(error && error.message ? error.message : null, button);
      throw error;
    } finally {
      addInFlight = false;
      setSkipOpen(false);
      if (button) button.disabled = false;
    }
  }

  function bindButton(button, buildFormData, options) {
    if (!button || typeof buildFormData !== 'function') return;
    if (button.dataset && button.dataset.revivalCartBound === '1') return;
    if (button.dataset) button.dataset.revivalCartBound = '1';

    button.addEventListener('click', async function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        var formData = await buildFormData(event);
        await add(formData, Object.assign({}, options || {}, { button: button }));
      } catch (e) {
        // add() already logs and renders customer-facing errors.
      }
    });
  }

  window.RevivalCart = {
    add: add,
    bindButton: bindButton,
    refresh: getShopifyCart,
    syncRebuy: syncRebuy,
    debug: function (enabled) {
      try {
        if (enabled) window.sessionStorage.setItem(DEBUG_KEY, '1');
        else window.sessionStorage.removeItem(DEBUG_KEY);
      } catch (e) {}
    },
    isBusy: function () { return addInFlight; },
    getFailures: function () {
      try { return JSON.parse(window.sessionStorage.getItem('revival_cart_failures') || '[]'); }
      catch (e) { return []; }
    }
  };
})();
